<template>
  <div class="login__form">
    <div class="login__forminput" v-show="!auth.loading && tab.id !== 3">
      <img
        class="login__forminput-img"
        src="../../src/assets/img/bankid.png"
        alt="BankID logo"
        v-if="tab.id === 2"
      />

      <input
        class="login__forminput-input"
        type="text"
        placeholder="ååmmddxxxx"
        v-model="personNr"
        v-if="tab.id === 1"
      />
    </div>

    <div class="login__qr" v-if="tab.id === 3" >
      <ol class="login__qr-list">
        <li class="login__qr-list__item">Öppna BankID-appen i mobilen.</li>
        <li class="login__qr-list__item">Tryck på QR-symbolen i BankID-appen.</li>
        <li class="login__qr-list__item">Rikta kameran mot QR-koden i denna ruta.</li>
      </ol>

      <Button
        v-if="hideQR"
        @click="triggerQR"
        @click.native="triggerQR"
        :msg="'Visa QR-kod'"
        :class="'button--primary'"
        :icon="'fas fa-qrcode'"
      />

      <img
        v-else
        class="login__qr-img"
        :src="auth.qrLink"
      >
    </div>

    <div class="login__loading" v-show="auth.loading">
      <p class="message" v-if="auth.msg != ''">{{ auth.msg }}</p>

      <LoadingSpinner />

      <Button
        v-if="tab.btn"
        :msg="tab.btn"
        :class="'button--primary'"
        v-show="!auth.loading"
        @click="handleLogin"
        @click.native="handleLogin"
      />

      <p
        v-show="auth.checkStatus"
        :style="{ textDecoration: 'underline', cursor: 'pointer' }"
        @click="cancelSignIn(auth.orderRef)"
        class="login__text"
      >
        Avbryt
      </p>
    </div>
  </div>
</template>

<script>
import Button from './elements/Button';
import LoadingSpinner from './elements/LoadingSpinner';
import { mapActions, mapGetters } from 'vuex';
import { validatePersonalnumber } from '../services/validation';

export default {
  data() {
    return {
      personNr: '',
    }
  },
  props: {
    tabs: Array,
    tab: Object
  },
  components: { Button, LoadingSpinner },
  methods: {
    ...mapActions(['signIn', 'cancelSignIn']),
    handleLogin () {
      if (this.tab.id == 1) {
        if (validatePersonalnumber(this.personNr)) {
          let ssn = this.personNr.replace("-", "");

          if (ssn.length == 10) {
            if (ssn.startsWith(0)) {
              ssn = '20'.concat(ssn);
            } else {
              ssn = '19'.concat(ssn);
            }
          }

          this.signIn({
            'personNr': ssn,
            'signInMethod': this.tab.id
          })
        }
      }

      if (this.tab.id == 2) {
        this.signIn({
          'personNr':this.personNr,
          'signInMethod':this.tab.id
        })
      }
    },
    triggerQR () {
      this.signIn({
        'personNr': "",
        'signInMethod': this.tab.id
      })
    }
  },
  computed: {
    ...mapGetters(['auth', 'user']),
    hideQR: function () {
      return this.auth.qrLink === '' && !this.auth.loading
    }
  },
  watch: {
    tabs: function () {
      this.error = '';
    },
    auth (newValue, oldValue) {
      if (newValue.loggedIn) {
        location.reload()
      }
    },
    tab: function() {
      this.cancelSignIn(this.auth.orderRef)

      if (this.tab.id == 3 && !this.hideQR) {
        this.signIn({
          'personNr': "",
          'signInMethod': this.tab.id
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login__loading {
  @extend %column;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
}

.login__form {
  @extend %center-content;
  border: 1px solid $borderColor;
  border-top: none;
  flex-direction: column;
  flex: 1;
  background-color: #fefefe;
  border-bottom-left-radius: $borderRadius;
  border-bottom-right-radius: $borderRadius;
}

.login__qr {
  padding: 10px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &-list {
    font-family: "Roboto", sans-serif;
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
    counter-reset: li;

    li:not(:last-of-type) {
      margin-bottom: 10px;
    }

    &__item {
      counter-increment: li;

      &:before {
        content: counter(li) ".";
        color: green;
        font-weight: bold;
        margin-right: 5px;
      }
    }
  }

  &-img {
    width: 120px;
    margin-top: 30px;
  }
}

.login__forminput {
  @extend %center-content;
  flex-direction: column;
  width: 100%;
  margin-bottom: 2rem;

  &-img {
    width: 6.25rem;
  }

  &-input {
    background: #EFEFEF45 url('../assets/img/bankid.png') no-repeat top .5rem right .5rem;
    background-size: 2.75rem;
    border: 1px solid #70707024;
    border-radius: $borderRadius;
    height: 4rem;
    padding: 0 1rem;
    font-size: 1rem;
    color: $gray;
    outline: none;
    margin-top: 2rem;
    width: 90%;

    @include breakpoints(small) {
      width: 50%;
    }

    &::placeholder {
      font-family: $btnText;
      color: rgba(67, 66, 93, 0.809);
    }
  }
}

.error-message {
  color: $red;
  font-weight: 500;
  font-size: 1em;
  text-align: center;
}

.message {
  font-size: 1em;
  font-weight: normal;
  max-width: 18.75rem;
  min-height: 2rem;
  text-align: center;
}
</style>